import type { IPlatformDashboardDailySignupBucket } from '@brushfire/types'

/** M/D tick label — matches Figma 37:1424 x-axis. */
export function formatNewSignupsDayLabel(date: string): string {
  const parsed = new Date(`${date}T00:00:00`)
  if (Number.isNaN(parsed.getTime())) return date
  return `${parsed.getMonth() + 1}/${parsed.getDate()}`
}

/** Full date for tooltips — US-PAD-1-23. */
export function formatNewSignupsTooltipDate(date: string): string {
  const parsed = new Date(`${date}T00:00:00`)
  if (Number.isNaN(parsed.getTime())) return date
  return parsed.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

/** Show every Nth day label on a 30-day window (Figma ~3-day spacing). */
export function shouldShowNewSignupsXTick(index: number, total: number, step = 3): boolean {
  if (total <= 0) return false
  if (index === 0 || index === total - 1) return true
  return index % step === 0
}

export function maxSignupCount(buckets: IPlatformDashboardDailySignupBucket[]): number {
  return buckets.reduce((max, bucket) => Math.max(max, bucket.count), 0)
}

/** Y-axis max + step — e.g. 0–3000 in steps of 500 when peak is ~3000. */
export function computeNewSignupsYScale(maxCount: number): { max: number; stepSize: number } {
  if (maxCount <= 0) {
    return { max: 100, stepSize: 20 }
  }

  const targetTicks = 6
  const roughStep = maxCount / targetTicks
  const magnitude = 10 ** Math.floor(Math.log10(roughStep))
  const normalized = roughStep / magnitude
  const niceNormalized = normalized <= 1 ? 1 : normalized <= 2 ? 2 : normalized <= 5 ? 5 : 10
  const stepSize = niceNormalized * magnitude
  const max = Math.ceil(maxCount / stepSize) * stepSize
  return { max: Math.max(max, stepSize), stepSize }
}
